"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.skCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var skCountry = exports.skCountry = function skCountry(t) {
  return {
    id: 'SK',
    name: t('Slovakia'),
    flag: '🇸🇰',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{3}\s?[0-9]{2}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 811 01 or 040 01',
    phonePrefix: '421',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Bratislava',
    currency: 'EUR'
  };
};